import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Card,
  CardContent,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@cargomatic/ui';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import SendDOEmailModal from '../shipments/SendDOEmailModal';
import { Documents } from '../documents/Documents';
import AdminServerActionCreators from '../../../actions/AdminServerActionCreators';
import { orderDocTypes } from '../../../config/documents';
import { ShipmentDocumentList } from './ShipmentDocumentList';

export const OrderDocuments = ({ order, shipments }) => {
  const { t } = useTranslation();
  const [showEmailDeliveryOrderModal, setShowEmailDeliveryOrderModal] =
    useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleSendEmails = (emails) => {
    OrdersActionCreators.emailCustomDeliveryOrder(
      order._id,
      selectedDocumentId,
      emails,
    );
  };

  const handleShowEmailDeliveryOrderModal = (documentId) => {
    setShowEmailDeliveryOrderModal(true);
    setSelectedDocumentId(documentId);
  };

  const handleHideEmailDeliveryOrderModal = () => {
    setShowEmailDeliveryOrderModal(false);
    setSelectedDocumentId(null);
  };

  return (
    <Card id="order-documents">
      <CardContent className="pt-6">
        <Tabs defaultValue="order" className="w-full">
          <div className="overflow-x-auto">
            <TabsList className="inline-flex w-full min-w-fit">
              <TabsTrigger value="order" className="whitespace-nowrap flex-1">
                {t('ORDER_DOCUMENTS')}
              </TabsTrigger>
              <TabsTrigger
                value="shipment"
                className="whitespace-nowrap flex-1"
              >
                {t('ASSOCIATED_SHIPMENT_DOCS')}
              </TabsTrigger>
            </TabsList>
          </div>
          <TabsContent value="order" className="mt-6">
            <Documents
              shipment={order}
              isOrder
              onEmail={handleShowEmailDeliveryOrderModal}
              onUpload={(uploadedOrder) => {
                AdminServerActionCreators.uploadOrderDocumentSuccess(
                  uploadedOrder,
                );
              }}
              onUploadFailed={(_uploadedOrder, _stop, e) => {
                AdminServerActionCreators.uploadOrderDocumentFail({
                  error: e?.message,
                });
              }}
              shipments={shipments}
              docTypes={orderDocTypes}
              pageNeighbours={0}
            />
          </TabsContent>
          <TabsContent value="shipment" className="mt-6">
            <ShipmentDocumentList shipments={shipments} />
          </TabsContent>
        </Tabs>
      </CardContent>
      {showEmailDeliveryOrderModal && (
        <SendDOEmailModal
          show={showEmailDeliveryOrderModal}
          onSend={handleSendEmails}
          onHide={handleHideEmailDeliveryOrderModal}
        />
      )}
    </Card>
  );
};

OrderDocuments.propTypes = {
  order: PropTypes.object,
  shipments: PropTypes.array,
};
